'use client';

import { CalendarIcon } from '@fe-common-ui/Icons';
import { formatTime, isToday } from '@fe-common-utils/libs/time';
import { useDateContext } from '@fe-news/hooks/use-date-context';
import { styled } from '@linaria/react';

const MILLISECONDS = 1000;

const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const Today = styled.div`
  font-size: 20px;
  color: #515c69;
  line-height: 24px;
`;

// 手機版日期元件
// TODO: 元件有重複，直接用 `atoms/Calendar/Calendar.tsx` 代替

const Calendar = () => {
  const { dates } = useDateContext();

  const endDate = dates?.[1]?.getTime() || Date.now();
  const isDateToday = isToday(endDate);
  const title = isDateToday ? '今天' : formatTime(endDate / MILLISECONDS, 'MMDD');

  return (
    <CalendarContainer>
      {isDateToday && <CalendarIcon timestamp={endDate} marginRight={8} />}
      <Today>{title}</Today>
    </CalendarContainer>
  );
};

export default Calendar;
